import { useNavigate, useParams } from "react-router-dom";
import Input, { required, submitForm, useAreaInput, useInput, useTextInput } from "../../components/input";
import LoadingButton from "../../components/LoadingButton";
import { useState } from "react";
import { api } from "../../env";
import { setStorage, STORAGE } from "../../utils/storage";

export default function SignUp() {

    const navigate = useNavigate()

    const { code } = useParams()
    const [loading, setLoading] = useState(false)
    const [accountCreated, setAccountCreated] = useState(false)
    
    const registerForm = {
        // TODO Password checks
        password: useInput("Password", "lock_open", "password", [required]),
        repeatPassword: useInput("Repeat Password", "lock", "password", [required]),
        firstName: useTextInput("Name", "person", [required]),
        lastName: useTextInput("Surname", "", [required])
    }

    const additionalForm = {
        email: useInput("Email", "email", "email", [required]),
        organization: useAreaInput("Name of your Sponsor Organisation (or) Employer?", "article_person", [], 3, 10, undefined, "Enter the name of your employer, or other organisation that is sponsoring your mentorship program.")
    }

    const createAccount = () => {
        if (code) signUpCode()
        else signUp()
    }

    const signUpCode = () => {
        const registerInfo = submitForm(registerForm)
        if (!registerInfo) return
        setLoading(true)
        let { repeatPassword, ...request } = registerInfo
        request = { 
            ...request,
            signUpCode: code
        }
        api.post('accounts/signup/invitation', request)
            .then(res => {
                setStorage(STORAGE.PARTICIPANT_INVITE_MADE_ACCOUNT, true)
                setLoading(false)
                navigate('/')
            })
            .catch(err => {
                setLoading(false)
            })    
    }

    const signUp = () => {
        const registerInfo = submitForm(registerForm)
        const additionalInfo = submitForm(additionalForm)
        if (!registerInfo) return
        if (!additionalInfo) return
        setLoading(true)
        let { repeatPassword, ...request } = registerInfo
        request = { 
            ...request,
            ...additionalInfo
        }
        api.post('accounts/signup', request)
            .then(res => {
                setStorage(STORAGE.PARTICIPANT_INVITE_MADE_ACCOUNT, true)
                setLoading(false)
                setAccountCreated(true)
            })
            .catch(err => {
                setLoading(false)
            })    
    }

    const handleLogin = () => {
        setStorage(STORAGE.PARTICIPANT_INVITE_MADE_ACCOUNT, true) // This is here in case a participant does have an account and just want's to simply login.. This wouldn't be necessary if we just let the user land on a login page and manually go to sign up which we'll hopefully be able to revert to..
        navigate('/')
    }

    return(
        <div className="flex columns gap-xs showing" style={{width: 'clamp(200px, 85%, 320px)', padding: '64px 0'}}>
            {!accountCreated && <>
                <p className="section-title">Create Account</p>
                {!code && <>
                    <Input state={additionalForm.email} />
                    <Input state={additionalForm.organization} />

                </>}
                <Input state={registerForm.password} />
                <Input state={registerForm.repeatPassword} />
                <div className="two-columns gap-xs" style={{maxWidth: "340px"}}>
                    <Input state={registerForm.firstName} />
                    <Input state={registerForm.lastName} />
                </div>
                <p className="card-label text-center neutral">By signing up, you agree to our <a className="bold accent" href="https://mentormatches.ai/terms">Terms of Use</a> and acknowledge our <a className="bold accent" href="https://mentormatches.ai/privacy">Privacy Policy</a></p>
                <LoadingButton className={'solid-accent large'} label={'Sign Up'} loading={loading} onClick={createAccount}/>
                <div className="flex gap-xs center justify-center">
                    <p className="card-label">Already have an account?</p>
                    <button className="text" onClick={handleLogin}>Login</button>
                </div>
            </>}
            {accountCreated && <div className="flex columns gap-l center justify-center showing">
                <p className="section-title">Verify Account</p>
                <p className="card-body text-center">We've sent a verification email to your registered email address. Please click the link in the email to verify your account and complete the setup.</p>
                <button className="outline" onClick={handleLogin}>Back to Login</button>
            </div>}
        </div>
    )
    
}